import React, { Fragment, useState } from 'react';
import { toast } from 'react-toastify';
import { DropdownArrow2, ImgLoaderWhite } from '../../../../assets/images';
import ActionInfoPopup from '../../../ActionInfoPopup';
import { blockOfflineAction, logout, OutsideClickHandler, stripTags } from '../../../../Helpers/Utility';
import SDK from '../../../SDK';
import Button from '../../../../ui/Button';
import { reason as reasons } from './reason';

const UserFeedbackForm = () => {
    const maxFeedbackValue = 250;
    const [dropActive, setDropActive] = useState(false);
    const [confirmPopup, setConfirmPopup] = useState(false);
    const [reason, setReason] = useState('');
    const [feedback, setFeedback] = useState('');
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState({
        errorPopup: false,
        errorMessage: '',
    });
    const { errorPopup, errorMessage } = error;

    const handleDropChange = e => {
        setReason(e.target.value);
    };

    const handleDeletePopup = () => {
        if (reason === '') {
            setError({
                errorPopup: true,
                errorMessage: 'Please select a reason',
            });
            return;
        }
        setConfirmPopup(true);
    };

    const handleDeleteConfirm = async _state => {
        if (reason === '') {
            setError({
                errorPopup: true,
                errorMessage: 'Please select a reason',
            });
            return;
        }
        if (blockOfflineAction()) return;
        setConfirmPopup(false);
        setIsLoading(true);
        await SDK.endCall();
        const deleteMyAccountResponse = await SDK.deleteMyAccount(reason, feedback);
        setIsLoading(false);
        if (deleteMyAccountResponse.statusCode === 200) {
            logout('accountDeleted');
        } else {
            toast.error('The server is not responding. Please try again later.');
        }
    };

    const handleFeedbackChange = e => {
        if (e.target.innerText.length <= maxFeedbackValue) {
            setFeedback(e.target.innerText);
        }
    };

    const pasteAsPlainTextFeedback = (e = {}) => {
        let text = feedback + e?.clipboardData?.getData('text/plain');
        text = stripTags(text);
        if (text.length >= maxFeedbackValue) {
            e.preventDefault();
            text = text.substring(0, maxFeedbackValue);
            if (document && document.activeElement instanceof HTMLElement) {
                const remainingText = e?.clipboardData
                    ?.getData('text/plain')
                    .substring(0, maxFeedbackValue - feedback.length);
                document.activeElement.textContent += remainingText;
            }
        }
        setFeedback(text);
    };

    return (
        <Fragment>
            {isLoading && (
                <div className="page-loader">
                    <img src={ImgLoaderWhite} alt="contact-us" />
                </div>
            )}
            <div className="user_feedback_wraper">
                <div className="drop_custom">
                    <span>We hate to see you leave! Tell us why you are deleting your account:</span>
                    <div className={`${dropActive ? ' open ' : ' '} form-group `}>
                        <div className={`${dropActive ? ' open ' : ' '} inputGroup `}>
                            <label
                                htmlFor="country"
                                tabIndex="0"
                                role="button"
                                onClick={() => setDropActive(!dropActive)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        setDropActive(!dropActive);
                                        e.preventDefault();
                                    }
                                }}
                                className={`${dropActive ? ' open ' : ' '} dropArrow`}
                            >
                                <DropdownArrow2
                                    aria-hidden="true"
                                    className={`${dropActive ? ' open ' : ' '} `}
                                    style={{ transform: dropActive ? 'rotate(-180deg)' : 'rotate(0deg)' }}
                                />
                            </label>
                            <div
                                id="country"
                                className={`${dropActive ? ' open ' : ''} DropContainer`}
                                tabIndex="0"
                                role="button"
                                onClick={() => setDropActive(!dropActive)}
                                onKeyDown={e => {
                                    if (e.key === 'Enter' || e.key === ' ') {
                                        setDropActive(!dropActive);
                                        e.preventDefault();
                                    }
                                }}
                            >
                                <div
                                    onClick={() => setDropActive(!dropActive)}
                                    className={`${dropActive ? ' open ' : ''} selected`}
                                    tabIndex={0}
                                    role="button"
                                    onKeyDown={e => {
                                        if (e.key === 'Enter' || e.key === ' ') {
                                            setDropActive(!dropActive);
                                            e.preventDefault();
                                        }
                                    }}
                                >
                                    {reason || 'Select a reason'}
                                </div>
                                {dropActive && (
                                    <OutsideClickHandler
                                        onOutsideClick={event => {
                                            if (event.target.classList.contains('open')) return;
                                            setDropActive(false);
                                        }}
                                    >
                                        <div className="drop_options ">
                                            {reasons.map(reasonData => {
                                                return (
                                                    <Button
                                                        variant="ghost"
                                                        type="button"
                                                        className="drop_options_list list_type_1"
                                                        onClick={handleDropChange}
                                                        value={reasonData.reason}
                                                        key={reasonData.id}
                                                    >
                                                        {reasonData.reason}
                                                    </Button>
                                                );
                                            })}
                                        </div>
                                    </OutsideClickHandler>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className="form_group contentEditable_wraper">
                        <textarea
                            id="typingContainer"
                            placeholder="Tell us how we can improve"
                            className="contentEditable"
                            contentEditable={true}
                            aria-label="Feedback input field"
                            onInput={handleFeedbackChange} //NOSOANR
                            onPaste={pasteAsPlainTextFeedback} //NOSOANR
                        />
                    </div>

                    <span className="note">We will store your feedback for future purpose.</span>
                </div>
                <div className="user_feedback_footer">
                    <Button variant="destructive" className="btn_continue" onClick={handleDeletePopup} type="button">
                        Delete My Account
                    </Button>
                </div>
            </div>
            {confirmPopup && (
                <ActionInfoPopup
                    textActionBtn={'Ok'}
                    textCancelBtn={'Cancel'}
                    handleCancel={() => setConfirmPopup(false)}
                    handleAction={() => handleDeleteConfirm(true)}
                    textHeading={'Proceed to delete your account?'}
                    textInfo={
                        'Deleting your account is permanent. Your data cannot be recovered if you reactivate your Hike account in future.'
                    }
                />
            )}
            {errorPopup && (
                <ActionInfoPopup
                    textActionBtn={'Ok'}
                    handleAction={() => setError({ ...error, errorPopup: false })}
                    textInfo={errorMessage}
                />
            )}
        </Fragment>
    );
};

export default UserFeedbackForm;
